export function formatPrice(price) {
  return Number(price / 100);
}
